import React from 'react'
import DemoForm from '../../components/site/Forms/DemoForm'

export default function () {
    return (
        <div className="container home-solution">
            <div className="wrapper">
                <div className="first-col column"><h2 className='title'>A solução mais prática e completa do mercado para seu time de  vendas</h2></div>
                <div className="second-col column">
                    <h3 className='description'>O Mercos é um sistema de vendas completo para empresas que vendem para o atacado: com automação de pedidos, aplicativo de vendas externas, e-commerce B2B e solução de pagamentos. Tudo de forma prática, intuitiva e integrada ao seu ERP.<br /> <br /> Controle sua operação comercial de uma vez: melhore a comunicação com seus vendedores, acompanhe seu estoque e acesse indicadores em tempo real.</h3>
                    <DemoForm modalLink showOr inlineBtns trialAndDemo="comece grátis" />
                </div>
            </div>
        </div>
    )
}




// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/TwoCols/HomeSolutions.jsx